import type { ColumnDef } from '../projects/projectsColumns';

export const locationsManageColumns: ColumnDef[] = [
  { field: 'LocationId', headerName: 'Location ID', sortable: true, width: 130 },
  { field: 'LocationName', headerName: 'Location Name', sortable: true, flex: 1.2 },
  { field: 'LocationType', headerName: 'Type', sortable: true, width: 100 },
  { field: 'ProjectId', headerName: 'Project ID', sortable: true, width: 130 },
  { field: 'ProjectName', headerName: 'Project', sortable: true, flex: 1 },
  { field: 'SiteName', headerName: 'Site', sortable: true, flex: 0.8 },
  { field: 'SiteCity', headerName: 'City', sortable: true, width: 110 },
  { field: 'SampleCount', headerName: 'Samples', sortable: true, width: 90 },
];
